import { render } from "./Skills.vue?vue&type=template&id=10eddfd3&scoped=true"
import script from "./Skills.vue?vue&type=script&lang=js"
export * from "./Skills.vue?vue&type=script&lang=js"

import "./Skills.vue?vue&type=style&index=0&id=10eddfd3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-10eddfd3"

export default script